import {  Collapse, Icon, Menu, MenuDivider, MenuItem } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { connect } from 'react-redux';
import { Registry } from 'react-registry';
import ComponentRegistry from 'react-registry/dist/lib/ComponentRegistry';
import { bindActionCreators, Dispatch } from 'redux';
import { v4 as generateUuid } from "uuid";

import { FlexJustify } from "common/fragments/Flex";
import * as editActions from 'core/actions/editActions';
import initialState from 'core/reducers/initialState';


interface IViewListStateProps {
	views?: {
		[id: string]: {
			[variantId: string]: object;
		};
	};
}

interface IViewListDispatchProps {
	actions: typeof editActions;
}

type ResultProps = IViewListStateProps & IViewListDispatchProps;

interface IViewListState {
	expanded: {
		[viewId: string]: boolean;
	};
}

function mapStateToProps(state: typeof initialState = initialState): IViewListStateProps {

	return {
		views: state.config.views || {}
	};
}

function mapDispatchToProps(dispatch: Dispatch<typeof initialState>): IViewListDispatchProps {

	return {
		actions: bindActionCreators(editActions, dispatch)
	};
}

class ViewList extends React.Component<ResultProps, IViewListState> {

	public state = { expanded: { } };

	public render() {
		const registeredViews = (ComponentRegistry.getInstance().getRegistry("views") as any).registry.map;
		const viewLinks = Object.keys(registeredViews).map(this.renderView);

		return (
			<ul className="bp3-menu">{viewLinks}</ul>
		);
	}

	private renderView = (viewId: string) => {
		const viewData = this.props.views[viewId] || {};
		const variants = Object.keys(viewData);
		const defaultVariants = Registry.get({id: viewId, registry: 'variants', conditions: {view: true}}) as string[] || [];

		return (
			<li
				key={viewId}
				className={this.state.expanded[viewId] ? "bp3-menu-item bp3-active" : "bp3-menu-item"}
				onClick={this.toggleExpand(viewId)}
			>
				<div style={{width: "100%"}}>
					<FlexJustify>
						<span>{viewId}</span>
						<Icon icon={this.state.expanded[viewId] ? IconNames.CARET_DOWN : IconNames.CARET_RIGHT}/>
					</FlexJustify>

					<Collapse isOpen={this.state.expanded[viewId] === true}>
						<Menu key="variants">
							<MenuDivider title="Configured Variants" />
							{
								variants.length > 0 ? variants.map((variant) => {
										return (
											<MenuItem
												key={variant}
												onClick={this.selectVariant(viewId, variant)}
												text={this.props.views[viewId][variant]['__editName'] || "Untitled Variant"}
												label={defaultVariants.includes(variant) ? '(' + variant + ')' : undefined}
											/>
										);
									}
								) : (
									<MenuItem disabled={true} text="No Variants Configured" />
								)
							}
							<MenuDivider title="Add New Variants" />
							{
								defaultVariants && defaultVariants.map((k) => {
									if (viewData[k]) {
										return null;
									}
									return (
										<MenuItem icon={IconNames.PLUS} key={k} text={k} onClick={this.selectVariant(viewId, k)} />
									);
								})
							}
							<MenuItem key="custom" text="Add Custom Variant" onClick={this.addVariant(viewId)} />
						</Menu>
					</Collapse>
				</div>
			</li>
		);
	}

	private selectVariant = (viewId: string, instance: string) => () => {
		this.props.actions.editSetActive({type: "view", id: viewId, instance});
	}

	private addVariant = (viewId: string) => () => {
		this.props.actions.editSetActive({type: "view", id: viewId, instance: generateUuid()});
	}

	private toggleExpand = (viewId: string) => () => {
		this.setState((prev) => ({
			expanded: { ...prev.expanded, [viewId]: !prev.expanded[viewId] }
		}));
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewList);



// WEBPACK FOOTER //
// ./src/core/components/editor/views/ViewList.tsx